<script>
import { axiosGetPost } from '@router/axiosGetPost'
import CarrierCreate from '@components/contract/carrier-create'
import Multiselect from 'vue-multiselect'

export default {
  name: 'CarrierManager',
  props: {
    nameVariation: { type: String, default: null },
  },
  components: {
    CarrierCreate,
    Multiselect,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  data() {
    return {
      loading: false,
      carrier: null,
      displayName: null,
      carrierList: [],
      carrierVariation: this.nameVariation,
      carrierVariations: [],
      addNewCarrier: false,
    }
  },
  methods: {
    searchCarrier(name, loading) {
      axiosGetPost('post', '/cargofive/carriers/manage', {
        action: 'search',
        name,
      }).then((response) => {
        this.carrierList = response.list
      })
    },
    getVariations() {
      this.loading = true
      axiosGetPost('post', '/cargofive/carriers/manage', {
        action: 'list',
        carrierId: this.carrier.id,
      }).then((response) => {
        this.displayName = response.display_name
        this.carrierVariations = response.variations.map((h, i) => ({
          index: i,
          name: h,
          editing: false,
        }))
        this.loading = false
      })
    },
    manageVariation(action, variation, variationId = 0) {
      this.loading = true
      axiosGetPost('post', '/cargofive/carriers/manage', {
        carrierId: this.carrier.id,
        action,
        variation,
        variationId,
      }).then((response) => {
        this.carrierVariation = action === 'add' ? '' : this.carrierVariation
        this.carrierVariations = response.variations.map((h, i) => ({
          index: i,
          name: h,
          editing: false,
        }))
        this.loading = false
      })
    },
    addNew() {
      this.addNewCarrier = !this.addNewCarrier
      this.carrier = null
      this.carrierList = []
      this.carrierVariations = []
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="row form-group">
        <div class="col-10">
          <multiselect
            v-model="carrier"
            id="ajax"
            label="name"
            track-by="fullData"
            placeholder="Search carrier"
            open-direction="bottom"
            :multiple="false"
            :searchable="true"
            :loading="loading"
            :internal-search="false"
            :disabled="addNewCarrier"
            :reduce="(options) => options.id"
            :options="carrierList"
            @search-change="searchCarrier"
            @input="getVariations"
          ></multiselect>
        </div>
        <div class="col-2">
          <button
            v-if="addNewCarrier === false"
            class="btn btn-sm my-1 btn-outline-secondary"
            title="Add New"
            @click="addNew"
          >
            Add New <i class="uil uil-plus"></i>
          </button>
          <button
            v-else
            class="btn btn-sm my-1 btn-outline-danger"
            title="Add New"
            @click="addNew"
          >
            &nbsp;&nbsp;Cancel <i class="uil uil-multiply"></i>&nbsp;&nbsp;
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading && !addNewCarrier" class="col-12">
      <div
        class="row align-items-center justify-content-center"
        style="height: 350px"
      >
        <div class="col-12 col-md-8 text-center">
          <b-spinner
            label="Loading..."
            variant="secondary"
            class="ml-3"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div
      v-else-if="carrierVariations.length > 0 && !addNewCarrier"
      class="col-12"
    >
      <div class="row" style="height: 300px; overflow-y: scroll">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped mb-0">
              <tbody>
                <tr v-for="h in carrierVariations" :key="h.index">
                  <th scope="row">{{ h.index }}</th>
                  <td>
                    <input
                      v-if="h.editing"
                      v-model="h.name"
                      v-focus
                      class="w-100"
                      @keyup.enter="manageVariation('edit', h.name, h.index)"
                      @blur="manageVariation('edit', h.name, h.index)"
                    />
                    <p v-else>
                      {{ h.name }}
                    </p>
                  </td>
                  <td style="text-align: end">
                    <button
                      class="btn btn-sm btn-info ml-2"
                      @click="h.editing = !h.editing"
                    >
                      <i class="uil uil-edit"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger ml-2"
                      @click="manageVariation('delete', h.name)"
                    >
                      <i class="uil uil-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <input
            v-model="carrierVariation"
            type="text"
            class="form-control"
            placeholder="new variation"
          />
        </div>
        <div class="col-12 col-md-3">
          <button
            class="btn btn-success w-100"
            @click="manageVariation('add', carrierVariation)"
          >
            Add
          </button>
        </div>
      </div>
    </div>
    <div class="w-100" v-else-if="addNewCarrier">
      <CarrierCreate @update_view="addNew" />
    </div>
    <div v-else class="col-12">
      <div
        class="row align-items-center justify-content-center"
        style="height: 350px"
      >
        <div class="col-12 col-md-8 text-center">
          <feather type="anchor" class="icon-xxl icon-dual-info"></feather>
          <h6 class="text-muted">Select a carrier</h6>
        </div>
      </div>
    </div>
  </div>
</template>